// import * as React from 'react';
import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const Declaration = ({
  formData,
  setFormData,
  errors,
  setDeclarationErrors,
  commonError,
}) => {
  const handleChange = (name, value, e) => {
    if (e && e.target.type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: e.target.checked ? 1 : 0,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    // Clear individual field error
    const updatedErrors = { ...errors };
    updatedErrors[name] = "";

    const {
      declare_right_to_short_film,
      declare_have_all_necessary_permission,
      declare_non_commercial_publicity,
      declare_for_false_information,
      declare_for_correct_information,
      confirm,
    } = {
      ...formData,
      [name]: e.target.type === "checkbox" ? (e.target.checked ? 1 : 0) : value,
    };

    // Check if all checkboxes are checked
    if (
      declare_right_to_short_film &&
      declare_have_all_necessary_permission &&
      declare_non_commercial_publicity &&
      declare_for_false_information &&
      declare_for_correct_information &&
      confirm
    ) {
      updatedErrors.commonError = "All checkboxes must be checked.";
    } else {
      updatedErrors.commonError = "";
    }

    setDeclarationErrors(updatedErrors);
  };

  return (
    <container>
      <div className="container mt-3">
        <div className="cmot-phone">
          <h5>STEP 5</h5>
          <p>
            Declaration <span className="text-danger">*</span>
          </p>
        </div>
        <form>
          <Grid container spacing={2} className="mt-3">
            {/* Check Box */}
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declare_right_to_short_film"
                  checked={formData.declare_right_to_short_film === 1}
                  onChange={(e) =>
                    handleChange(
                      "declare_right_to_short_film",
                      formData.declare_right_to_short_film,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  label="I hereby declare that the works submitted by me are my own and that I have verifiable credit in the film."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declare_have_all_necessary_permission"
                  checked={formData.declare_have_all_necessary_permission === 1}
                  onChange={(e) =>
                    handleChange(
                      "declare_have_all_necessary_permission",
                      formData.declare_have_all_necessary_permission,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  label="I own the rights to the Short Film/ Portfolio/ Audio Track submitted, or have written consent from the rightful owner of the works to participate, which can be produced to the organizers if required."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declare_non_commercial_publicity"
                  checked={formData.declare_non_commercial_publicity === 1}
                  onChange={(e) =>
                    handleChange(
                      "declare_non_commercial_publicity",
                      formData.declare_non_commercial_publicity,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  label="I have obtained all the necessary permissions for this film and the film does not infringe the rights, including copyright, of any third party. This includes the use of music and literary material."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declare_for_false_informtion"
                  checked={formData.declare_for_false_informtion === 1}
                  onChange={(e) =>
                    handleChange(
                      "declare_for_false_informtion",
                      formData.declare_for_false_informtion,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  label="MoIB / NFDC / IFFI /  Production Partners reserve the right to use and/or reproduce materials received or their parts for non-commercial publicity of the programme/ event in case of selection."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declare_for_correct_informtion"
                  checked={formData.declare_for_correct_informtion === 1}
                  onChange={(e) =>
                    handleChange(
                      "declare_for_correct_informtion",
                      formData.declare_for_correct_informtion,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  // label="The information furnished above is true and correct to the best of my knowledge. I understand that in the event of my information being found false or incorrect at any stage, my application shall be liable to rejection/disqualification."
                  label="MoIB / NFDC / IFFI /  Production Partners reserve the right to get the submitted data verified by third parties."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declaration_tv_reserve"
                  checked={formData.declaration_tv_reserve === 1}
                  onChange={(e) =>
                    handleChange(
                      "declaration_tv_reserve",
                      formData.declaration_tv_reserve,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  // label="The information furnished above is true and correct to the best of my knowledge. I understand that in the event of my information being found false or incorrect at any stage, my application shall be liable to rejection/disqualification."
                  label="The information furnished above is true and correct to the best of my knowledge. I understand that in the event of my information being found false or incorrect at any stage and if any part of my submission is found to be plagiarized or not my own work, my application shall be liable to rejection / disqualification."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1 mt-3">
              <FormGroup>
                <FormControlLabel
                  required
                  name="declaration_assigned_department"
                  checked={formData.declaration_assigned_department === 1}
                  onChange={(e) =>
                    handleChange(
                      "declaration_assigned_department",
                      formData.declaration_assigned_department,
                      e
                    )
                  }
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  // label="If Selected, Confirm That You Are Available To Be In Goa From November 18th To November 26th."
                  label="I acknowledge that I may be assigned work in a department other than the film craft I have applied for."
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={12} className="p-1 mt-3">
              <FormGroup>
                <FormControlLabel
                  required
                  name="confirm"
                  checked={formData.confirm === 1}
                  onChange={(e) => handleChange("confirm", formData.confirm, e)}
                  control={
                    <Checkbox
                      style={{ color: "#2C3E50" }}
                      className="checkboxcmot"
                    />
                  }
                  // label="If Selected, Confirm That You Are Available To Be In Goa From November 18th To November 26th."
                  label="If selected, I confirm that I will be available and present at the event venue for the entire duration of the event."
                />
              </FormGroup>
            </Grid>
          </Grid>

          {errors.commonError && (
            <Grid item xs={12}>
              <p className="text-danger">{errors.commonError}</p>
            </Grid>
          )}
        </form>
      </div>
    </container>
  );
};

export default Declaration;
